"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBoxShadow = exports.getCSSVariableName = exports.join = exports.toKebab = exports.escapeValue = void 0;
var constants_1 = require("../constants");
/**
 * В строковых значениях токенов встречаются нежелательные символы,
 * их нужно очищать перед размещением в CSS Var или JSON.
 * @param {string|number} value
 * @return {string|number}
 */
var escapeValue = function (value) {
    if (typeof value === 'string') {
        return value.replace(/\s+/g, ' ');
    }
    return value;
};
exports.escapeValue = escapeValue;
var toKebab = function (k) { return k.replace(/[A-Z]/g, function (match) { return "-".concat(match.toLowerCase()); }); };
exports.toKebab = toKebab;
var join = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.filter(Boolean).join('-');
};
exports.join = join;
var getCSSVariableName = function (key, withDesignPrefix, withKebabCase) {
    if (withDesignPrefix === void 0) { withDesignPrefix = true; }
    if (withKebabCase === void 0) { withKebabCase = false; }
    var variable = withKebabCase ? (0, exports.toKebab)(key) : key;
    return withDesignPrefix ? "--".concat(constants_1.DESIGN_SYSTEM_PREFIX, "-").concat(variable) : "--".concat(variable);
};
exports.getCSSVariableName = getCSSVariableName;
var getBoxShadow = function (shadows) { return shadows.map(function (_a) {
    var origin = _a.origin;
    return origin;
}); };
exports.getBoxShadow = getBoxShadow;
//# sourceMappingURL=other.js.map